import React from 'react';
import { FiDatabase } from 'react-icons/fi';
import ServiceTemplate from './ServiceTemplate';

export default function DataAnalyticsService() {
  return (
    <ServiceTemplate
      slug="data-analytics"
      color="#059669"
      icon={<FiDatabase size={40} />}
      title="Data & Analytics Consulting"
      tagline="Transform raw data into competitive intelligence with modern pipelines and ML models."
      heroDescription="Data is only valuable when it drives decisions. We build the infrastructure, pipelines, and intelligence layers that turn your data into a strategic asset — from warehouse design to predictive models to real-time dashboards your leadership team actually uses."
      features={[
        { title: 'Data Warehouse Design', description: 'Modern warehouse architecture on Snowflake, BigQuery, or Redshift. Star/snowflake schemas, slowly changing dimensions, and cost-optimized query patterns.' },
        { title: 'ETL & Data Pipelines', description: 'Reliable, tested data pipelines with Airflow, dbt, Fivetran, or custom Python. We handle ingestion, transformation, quality checks, and orchestration.' },
        { title: 'Business Intelligence', description: 'Interactive dashboards and self-service analytics with Looker, Tableau, Metabase, or custom React dashboards. We design for adoption, not just accuracy.' },
        { title: 'Predictive Analytics & ML', description: 'Production ML models for forecasting, classification, anomaly detection, and recommendation. scikit-learn, XGBoost, PyTorch — whatever fits the problem.' },
        { title: 'Real-Time Streaming', description: 'Event-driven architectures with Kafka, Kinesis, or Pub/Sub. Real-time dashboards, alerting, and automated triggers.' },
        { title: 'Data Governance & Quality', description: 'Data catalogs, lineage tracking, PII detection, access controls, and automated quality monitoring to maintain trust in your data.' },
      ]}
      useCases={[
        { title: 'E-Commerce Analytics Platform', description: 'Built a real-time analytics platform processing 2M+ events/day for a DTC brand.', result: '22% increase in conversion through data-driven product recommendations' },
        { title: 'Financial Forecasting Engine', description: 'Deployed ML models predicting revenue with 94% accuracy for a mid-market SaaS company.', result: 'Board-ready forecasts updated daily, replaced manual spreadsheets' },
        { title: 'Healthcare Data Integration', description: 'Unified 7 disparate data sources into a single warehouse for a healthcare network.', result: '80% reduction in reporting time, HIPAA-compliant architecture' },
      ]}
      techStack={[
        'Snowflake', 'BigQuery', 'Redshift', 'PostgreSQL',
        'dbt', 'Airflow', 'Fivetran', 'Spark',
        'Python', 'pandas', 'scikit-learn', 'PyTorch', 'XGBoost',
        'Kafka', 'Kinesis', 'Looker', 'Tableau', 'Metabase',
        'AWS', 'GCP', 'Azure', 'Terraform',
      ]}
    />
  );
}
